import React, {Component} from 'react';
import {Form, DatePicker, Input, Select, Col, Checkbox, Row} from 'antd';
import {reqGetVendorsPlusDelete} from "../../../api";
import {JEWELLERY_JOB_TYPE, STATUS_JEWELLERY} from "../../../utils/const";
import moment from 'moment';
import _ from 'lodash';
import {regexMoney} from "../../../utils/utility";
import LinkButton from "../../LinkButton";
import SelectInput from '../../SelectInput';

const {Item} = Form;
const {Option} = Select;
const {TextArea} = Input;

class JewelleryAddUpdateForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      vendors: [],
    };
    props.setForm(props.form)
  }

  componentDidMount() {
    //get all vendors by type
    reqGetVendorsPlusDelete({searchName: 'jewellery', searchType: 'type'})
      .then(response => {
        const vendors = response.data;
        this.setState({vendors});
      })
      .catch(error => {
        console.log(error.response)
      });
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {
      description, start_date, job_type, requires_approval_cad, requires_approval_replica,requires_approval_resin,
      approved_resin,approved_cad,approved_replica, retail, vendor_id, status
    } = this.props.order_item;
    const {vendors} = this.state;

    return (
      <Form>
        <Row>
          <Col span={21}>
            <Item label="Job Type" labelCol={{span: 5}} wrapperCol={{span: 15}}>
              {getFieldDecorator('job_type', {
                initialValue: job_type || '',
                rules: [
                  {required: true, message: 'Job Type is required'},
                  {max: 40, message: 'Maximum 40 characters'}
                ]
              })(
                <SelectInput options={JEWELLERY_JOB_TYPE}/>
              )}
            </Item>
          </Col>
        </Row>
        <Row>
          <Col span={21}>
            <Item label="Description" labelCol={{span: 5}} wrapperCol={{span: 15}}>
              {
                getFieldDecorator('description', {
                  initialValue: description || '', //add or update
                  rules: [
                    {required: true, message: 'Description is required'},
                  ]
                })(
                  <TextArea rows={4}/>
                )
              }
            </Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Item label='Retail' labelCol={{span: 9}} wrapperCol={{span: 12}}>
              {
                getFieldDecorator('retail', {
                  initialValue: retail || '',
                  rules: [
                    {required: true, message: 'retail is required'},
                    {
                      pattern: regexMoney,
                      message: 'Number with 2 decimal places Only',
                    }
                  ]
                })(<Input/>)
              }
            </Item>
          </Col>
        </Row>
        <Row>
          <Col span={8} offset={1}>
            <Item label="Require CAD" labelCol={{span: 12}} wrapperCol={{span: 12}}>
              {getFieldDecorator('requires_approval_cad', {
                initialValue: requires_approval_cad || false,
                valuePropName: 'checked',
              })(
                <Checkbox></Checkbox>
              )}
            </Item>
          </Col>
          <Col span={7}>
            <Item label="Require Resin" labelCol={{span: 12}} wrapperCol={{span: 12}}>
              {getFieldDecorator('requires_approval_resin', {
                initialValue: requires_approval_resin || false,
                valuePropName: 'checked',
              })(
                <Checkbox></Checkbox>
              )}
            </Item>
          </Col>
          <Col span={8}>
            <Item label="Require Replica" labelCol={{span: 12}} wrapperCol={{span: 12}}>
              {getFieldDecorator('requires_approval_replica', {
                initialValue: requires_approval_replica || false,
                valuePropName: 'checked',
              })(
                <Checkbox></Checkbox>
              )}
            </Item>
          </Col>
        </Row>
        <Row>
          <Col span={8} offset={1}>
            <Item label="Approve CAD" labelCol={{span: 12}} wrapperCol={{span: 12}}>
              {getFieldDecorator('approved_cad', {
                initialValue: approved_cad || false,
                valuePropName: 'checked',
              })(
                <Checkbox></Checkbox>
              )}
            </Item>
          </Col>
          <Col span={7}>
            <Item label="Approve Resin" labelCol={{span: 12}} wrapperCol={{span: 12}}>
              {getFieldDecorator('approved_resin', {
                initialValue: approved_resin || false,
                valuePropName: 'checked',
              })(
                <Checkbox></Checkbox>
              )}
            </Item>
          </Col>
          <Col span={8}>
            <Item label="Approve Replica" labelCol={{span: 12}} wrapperCol={{span: 12}}>
              {getFieldDecorator('approved_replica', {
                initialValue: approved_replica || false,
                valuePropName: 'checked',
              })(
                <Checkbox></Checkbox>
              )}
            </Item>
          </Col>
        </Row>

        {
          !(_.isEmpty(this.props.order_item)) &&
          (
            <React.Fragment>
              <Row>
                <Col span={12}>
                  <Item label="Vendor" labelCol={{span: 9}} wrapperCol={{span: 12}}>
                    {getFieldDecorator('vendor_id', {
                      initialValue: vendor_id || '',
                    })(
                      <Select
                        showSearch
                        filterOption={(inputValue, option) =>
                          option.props.children
                            .toString()
                            .toLowerCase()
                            .includes(inputValue.toLowerCase())
                        }
                      >
                        {
                          vendors.map(item => <Option hidden={!!item.deleted_at} value={item.id}
                                                      key={item.id}> {item.name} </Option>)
                        }
                      </Select>
                    )}
                  </Item>
                </Col>
                <Col span={12}>
                  <Item label="Start Date" labelCol={{span: 9}} wrapperCol={{span: 12}}>
                    {
                      getFieldDecorator('start_date', {
                        initialValue: !(start_date) ? null : moment(start_date),
                      })(
                        <DatePicker/>
                      )
                    }
                  </Item>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  <Item label="Status" labelCol={{span: 9}} wrapperCol={{span: 12}}>
                    {getFieldDecorator('status', {
                      initialValue: status || '',
                    })(
                      <Select>
                        {
                          STATUS_JEWELLERY.map(item => <Option value={item} key={item}> {item} </Option>)
                        }
                      </Select>
                    )}
                  </Item>
                </Col>
              </Row>
              <Row>
                {!!vendor_id && <LinkButton onClick={() => this.props.deletePO()}>DELETE PO#</LinkButton>}
              </Row>
            </React.Fragment>
          )
        }
      </Form>
    )
  }
}

export default Form.create()(JewelleryAddUpdateForm)